import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UpdatePhotoEvents } from '../events/event-declarations';
import { builderDispatch } from 'customer_pages/_utils/ui';

const handleToggleChange = () =>
  builderDispatch.dispatch({
    type: UpdatePhotoEvents.TOGGLE_DUPLICATE_PHOTO_VIEW,
  });

/**
 * @param {object} props
 * @param {number} props.totalDuplicatesCount - The number of duplicate photos found.
 * @param {boolean} props.duplicatePhotoViewActive - Whether the duplicate photo view is currently active.
 */
const DuplicatePhotoViewToggle = ({
  totalDuplicatesCount,
  duplicatePhotoViewActive = false,
}) => {
  const disabled = !totalDuplicatesCount;
  const count = totalDuplicatesCount || 0;

  return (
    <div className="duplicate-photo-view-toggle d-flex align-items-center justify-content-end px-0">
      <label
        className={classNames('mr-2 mb-0', { 'text-muted': disabled })}
        htmlFor="duplicate-view-toggle">
        Show Duplicates<span className="d-none d-sm-inline"> ({count})</span>
      </label>
      <div className="custom-control custom-switch">
        <input
          type="checkbox"
          className="custom-control-input"
          id="duplicate-view-toggle"
          checked={duplicatePhotoViewActive}
          disabled={disabled}
          onChange={handleToggleChange}
        />
        <label
          className="custom-control-label"
          htmlFor="duplicate-view-toggle"
        />
      </div>
    </div>
  );
};

DuplicatePhotoViewToggle.propTypes = {
  totalDuplicatesCount: PropTypes.number,
  duplicatePhotoViewActive: PropTypes.bool,
};

export { DuplicatePhotoViewToggle };
